import { BadgeCheck } from 'lucide-react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { CredentialCards } from '../components/SidebarBanners'

/** Certification under Profile: the assessment and certification a learner can add to their profile. */
export function CertificationPage() {
  const { profile } = useAuth()

  // Learners only - the rail hides it from guardians, and a bookmarked link goes to their children.
  if (profile?.entityKind === 'GUARDIAN') return <Navigate to="/guardian" replace />

  return (
    <div>
      <h1 className="flex items-center gap-2 text-xl font-bold text-ink-900">
        <BadgeCheck size={18} className="text-sun-500" /> Certification
      </h1>
      <p className="text-sm text-ink-500">Take an assessment or earn a certification. Each opens in a new tab.</p>

      <div className="mt-5">
        <CredentialCards />
      </div>
    </div>
  )
}
